









































































import { Component, Vue } from 'vue-property-decorator';
import { Data } from './Meta';

@Component({})
export default class Property extends Vue {
  initData = new Data();

  changeTitle(value: string) {
    this.$emit("change-title", value);
  }
  
  changeDescription(value: string) {
    this.$emit("change-description", value);
  }
  
  changeSs1(file: File) {
    if (this.isNoImage(file)) {
      this.$emit("change-ss1", null);
      return;
    }

    const reader = new FileReader();
    reader.onload = this.changeSs1Result;
    reader.readAsDataURL(file);
  }
  _changeSs1Result(e: any) {
    const filePath = e.target.result;
    this.$emit("change-ss1", filePath);
  }
  changeSs1Result = this._changeSs1Result.bind(this);

  changeSs2(file: File) {
    if (this.isNoImage(file)) {
      this.$emit("change-ss2", null);
      return;
    }

    const reader = new FileReader();
    reader.onload = this.changeSs2Result;
    reader.readAsDataURL(file);
  }
  _changeSs2Result(e: any) {
    const filePath = e.target.result;
    this.$emit("change-ss2", filePath);
  }
  changeSs2Result = this._changeSs2Result.bind(this);

  changeIcon(file: File) {
    if (this.isNoImage(file)) {
      this.$emit("change-icon", null);
      return;
    }

    const reader = new FileReader();
    reader.onload = this.changeIconResult;
    reader.readAsDataURL(file);
  }
  _changeIconResult(e: any) {
    const filePath = e.target.result;
    this.$emit("change-icon", filePath);
  }
  changeIconResult = this._changeIconResult.bind(this);

  private isNoImage(file: File): boolean {
    if (!file) return true;
    if(!file.type.match('image.*')) {
      return true;
    } else return false;
  }
}
